import { useState } from "react";
import axios from "axios";
import { Bell, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BookNotify = ({ book, testid }) => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");
    try {
      const res = await axios.post(`${API}/book-notify`, { email, book });
      setMsg(res.data.message);
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  if (msg) {
    return (
      <div
        data-testid={`book-notify-success-${testid}`}
        className="mt-2 flex items-start gap-2 text-[#0A1628] text-sm border-t border-[#0A1628]/8 pt-4"
      >
        <Check size={16} className="text-[#C5A059] mt-0.5 flex-shrink-0" />
        <span>{msg}</span>
      </div>
    );
  }

  if (!open) {
    return (
      <button
        type="button"
        data-testid={`book-notify-open-${testid}`}
        onClick={() => setOpen(true)}
        className="mt-2 inline-flex items-center justify-center gap-2 w-full border border-[#0A1628]/25 text-[#0A1628] text-xs font-bold uppercase tracking-widest px-4 py-2.5 hover:bg-[#0A1628] hover:text-[#F5F0E8] transition-colors"
      >
        <Bell size={13} /> Notify Me at Launch
      </button>
    );
  }

  return (
    <form
      data-testid={`book-notify-form-${testid}`}
      onSubmit={submit}
      className="mt-2 border-t border-[#0A1628]/8 pt-4"
    >
      <label className="text-[10px] text-[#C5A059]/70 uppercase tracking-[0.2em] font-mono mb-2 block">
        Get an email when this book launches
      </label>
      <div className="flex flex-col sm:flex-row gap-2">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          data-testid={`book-notify-input-${testid}`}
          className="flex-1 bg-[#F5F0E8] border border-[#0A1628]/20 text-[#0A1628] placeholder-[#2D3142]/40 px-3 py-2 text-sm focus:outline-none focus:border-[#C5A059]"
        />
        <button
          type="submit"
          disabled={saving}
          data-testid={`book-notify-submit-${testid}`}
          className="bg-[#C5A059] text-[#0A1628] px-4 py-2 text-xs font-bold uppercase tracking-widest hover:bg-[#0A1628] hover:text-[#F5F0E8] transition-colors disabled:opacity-50"
        >
          {saving ? "..." : "Notify Me"}
        </button>
      </div>
      {error && (
        <p data-testid={`book-notify-error-${testid}`} className="text-red-600 text-xs mt-2">{error}</p>
      )}
    </form>
  );
};
